import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=fd5fcca6"
import script from "./HistoricalData.vue?vue&type=script&lang=js"
export * from "./HistoricalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports